var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10.783,
    viewBox: "0 0 14 10.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_133-right-arrow",
    "data-name": "133-right-arrow",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740",
    transform: "translate(0 4.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M13.434,235.318H.566a.566.566,0,0,0,0,1.131H13.434a.566.566,0,0,0,0-1.131Z",
    transform: "translate(0 -235.318)",
    fill: "#868eae"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(8.043 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M299.939,63.821,295.113,59a.566.566,0,1,0-.8.8l4.426,4.426-4.426,4.426a.566.566,0,1,0,.8.8l4.826-4.826A.566.566,0,0,0,299.939,63.821Z",
    transform: "translate(-294.148 -58.83)",
    fill: "#868eae"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.e2a9f4b720ac4c3cb6e8997b5583d631.svg";
export { ForwardRef as ReactComponent };